<template>
  <div
    class="p-drawer-menu-sp"
    :class="{ 'p-drawer-menu-sp--hide': hideSideMenu }"
  >
    <div
      v-if="isShow"
      class="p-drawer-menu-sp__overlay"
      @click.stop="$emit('hide')"
    ></div>
    <div
      class="p-drawer-menu-sp__inner"
      :class="{ 'p-drawer-menu-sp__inner--open': isShow }"
    >
      <div class="p-drawer-menu-sp__list p-drawer-menu-sp__list--loggedIn">
        <template v-if="$auth.loggedIn">
          <div class="p-drawer-menu-sp__head">
            <template
              v-if="userData.familyName || userData.firstName"
              wovn-ignore
            >
              <div class="p-drawer-menu-sp__head__wrapper">
                <span class="p-drawer-menu-sp__head--userName">{{ userName }}様 </span>
                <div v-if="userData.ssoPrincipalFlg == 1" class="l-header__menu__item__label--self">
                  本人
                </div>
                <div v-if="userData.ssoPrincipalFlg == 0" class="l-header__menu__item__label--family">
                  家族
                </div>
              </div>
              <span class="p-drawer-menu-sp__head--userInfo">
                会員ID：{{ userData.ssoCustomerNo }}
              </span>
            </template>
            <span v-else wovn-ignore>氏名未設定</span>
          </div>
          <a
            v-if="isLogin && isShowCafeteriaPoint && userData.cafePoint >= 0"
            :href="domainCafe"
            target="_blank"
          >
            <div class="p-drawer-menu-sp__item--benepo">
              <div class="p-drawer-menu-sp__cafe">
                <p class="p-drawer-menu-sp__cafe--title">カフェ</p>
                <p class="p-drawer-menu-sp__cafe--point">
                  {{ formatNumber(userData.cafePoint) }}<span>P</span>
                </p>
              </div>
              <div
                class="p-drawer-menu-sp__arrow p-drawer-menu-sp__arrow--right"
              ></div>
            </div>
          </a>
          <a :href="domainMypage + '/mypage/benepo?currentID=0'">
            <div class="p-drawer-menu-sp__item--benepo">
              <div class="p-drawer-menu-sp__benepo">
                <p class="p-drawer-menu-sp__benepo--title">ベネポ</p>
                <p class="p-drawer-menu-sp__benepo--point">
                  {{ formatNumber(userData.totalPoint) }}<span>P</span>
                </p>
              </div>
              <div
                class="p-drawer-menu-sp__arrow p-drawer-menu-sp__arrow--right"
              ></div>
            </div>
          </a>
        </template>

        <div v-if="!$auth.loggedIn" class="w-full h-full px-2.5 py-3 bg_pink">
          <a class="block w-full h-full py-2 text-white text-center font-bold text-sp-base bg_red rounded_3px" :href="redirectUrl">ログイン</a>
        </div>

        <div class="p-drawer-menu-sp__section">クーポン</div>
        <a :href="domainMypage + '/mypage/coupon?sort=displayFrom'">
          <div
            class="p-drawer-menu-sp__item"
          >
            <div class="p-drawer-menu-sp__subitem"></div>
            <span>マイクーポン</span>
            <div
              class="p-drawer-menu-sp__arrow p-drawer-menu-sp__arrow--right"
            ></div>
          </div>
        </a>
        <a v-if="isLogin && isShowSupplementaryCoupon" :href="domainMypage + '/mypage/coupons'">
          <div class="p-drawer-menu-sp__item">
            <div class="p-drawer-menu-sp__subitem"></div>
            <span>補助クーポン</span>
            <div
              class="p-drawer-menu-sp__arrow p-drawer-menu-sp__arrow--right"
            ></div>
          </div>
        </a>
        <div class="p-drawer-menu-sp__section">会員証</div>
        <a :href="domainMypage + '/mypage/personalcard'">
          <div
            class="p-drawer-menu-sp__item"
          >
            <div class="p-drawer-menu-sp__subitem"></div>
            <span>Web会員証</span>
            <div
              class="p-drawer-menu-sp__arrow p-drawer-menu-sp__arrow--right"
            ></div>
          </div>
        </a>
        <a v-if="isLogin" :href="lifeDomain + '/oneTimePassword'">
          <div class="p-drawer-menu-sp__item">
            <div class="p-drawer-menu-sp__subitem"></div>
            <span>ファミリーマート <br>(ワンタイムパス)</span>
            <div
              class="p-drawer-menu-sp__arrow p-drawer-menu-sp__arrow--right"
            ></div>
          </div>
        </a>
        <div class="p-drawer-menu-sp__section">お気に入り</div>
        <a :href="domainMypage + '/mypage/favorites'">
          <div class="p-drawer-menu-sp__item">
            <div class="p-drawer-menu-sp__subitem"></div>
            <span>お気に入り</span>
            <div
              class="p-drawer-menu-sp__arrow p-drawer-menu-sp__arrow--right"
            ></div>
          </div>
        </a>
        <div class="p-drawer-menu-sp__section">閲覧履歴</div>
        <a :href="domainMypage + '/mypage/visits'">
          <div class="p-drawer-menu-sp__item">
            <div class="p-drawer-menu-sp__subitem"></div>
            <span>閲覧履歴</span>
            <div
              class="p-drawer-menu-sp__arrow p-drawer-menu-sp__arrow--right"
            ></div>
          </div>
        </a>


        <div class="p-drawer-menu-sp__section">申込履歴</div>
        <a :href="domainMypage +'/mypage/orders'">
          <div class="p-drawer-menu-sp__item items-start">
            <div class="p-drawer-menu-sp__subitem"></div>
            <div class="flex flex-col">
              <span>ライフサービス・トラベル</span>
            </div>
            <div
              class="p-drawer-menu-sp__arrow p-drawer-menu-sp__arrow--right"
            ></div>
          </div>
        </a>
        <!-- 退会者マイページリリースにともない旧サイト導線は削除 -->
        <!-- TODO:次回フェーズで使用する可能性があるため、コメントアウト -->
        <!-- <a target="_blank" :href="ssoShopUrl" class="external-link">
          <div class="p-drawer-menu-sp__item p-drawer-menu-sp__bottom-none items-start justify-between">
            <div class="flex">
              <div class="p-drawer-menu-sp__subitem"></div>
              <div class="flex flex-col">
                <span>ベネ通販</span>
              </div>
            </div>
            <div class="w-4 flex-shrink-0 flex">
              <img
                  src="@/assets/images/icon/arrow-up-right-from-square-solid.svg"
                  alt="arrow-up-right-from-square-solid_icon"
                  width="13" height="13"
                />
            </div>
          </div>
        </a> -->
        
        <!-- CRM汎用独自対応 -->
        <!-- <a target="_blank" :href="`${ isKyutokuMember ? qtokPaymentUrl : 'https://bs.benefit-one.inc/otherPage?other_id=kyuutoku_mypage' }`">
          <div class="p-drawer-menu-sp__item p-drawer-menu-sp__bottom-none items-start">
            <div class="p-drawer-menu-sp__subitem"></div>
            <div class="flex flex-col">
              <span>給トク払い</span>
            </div>
            <div
              class="p-drawer-menu-sp__arrow p-drawer-menu-sp__arrow--right"
            ></div>
          </div>
        </a> -->

        <div class="p-drawer-menu-sp__section">会員設定</div>
        <a :href="domainMypage + '/mypage/setting'">
          <div class="p-drawer-menu-sp__item">
            <div class="p-drawer-menu-sp__subitem"></div>
            <span>会員設定</span>
            <div
              class="p-drawer-menu-sp__arrow p-drawer-menu-sp__arrow--right"
            ></div>
          </div>
        </a>
        <div class="p-drawer-menu-sp__section">ご利用ガイド</div>
        <a :href="domainTop + '/otherPage?other_id=goriyou'">
          <div class="p-drawer-menu-sp__item">
            <div class="p-drawer-menu-sp__subitem"></div>
            <span>ご利用ガイド</span>
            <div
              class="p-drawer-menu-sp__arrow p-drawer-menu-sp__arrow--right"
            ></div>
          </div>
        </a>
        <div class="p-drawer-menu-sp__section">お知らせ</div>
        <a :href="domainTop + '/information'">
          <div class="p-drawer-menu-sp__item">
            <div class="p-drawer-menu-sp__subitem"></div>
            <span>お知らせ</span>
            <div
              class="p-drawer-menu-sp__arrow p-drawer-menu-sp__arrow--right"
            ></div>
          </div>
        </a>
          <router-link
            v-if="$auth.loggedIn"
            class="p-drawer-menu-sp__logout mt-4" 
            to="/"
            @click.native="loggedOut"
          >
            ログアウト
          </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isShow: {
      type: Boolean,
      default: false
    },
    isShowSupplementaryCoupon: {
      type: Boolean,
      default: false
    },
    isLogin: {
      type: Boolean,
      default: false
    },
    isShowCafeteriaPoint:{
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      hideSideMenu: false,
      resizeFlag: "",
      contractInfo: []
    };
  },
  computed: {
    ssoShopUrl() {
      return process.env.VUE_APP_SHOP_URL_SSO;
    },
    domainTop() {
      return process.env.VUE_APP_TOP_DOMAIN;
    },
    domainMypage() {
      return process.env.VUE_APP_MYPAGE_DOMAIN;
    },
    domainCafe() {
      const cafeUrl = process.env.VUE_APP_CAFE_SYS_URL;
      return cafeUrl;
    },
    lifeDomain() {
      return process.env.VUE_APP_LIFE_DOMEIN;
    },
    /**
     * ログインユーザー情報を取得して返却する
     * @return {object} - ログインユーザー情報のオブジェクト
     */
    userData() {
      if (!this.$auth || !this.$auth.user) return "";
      return this.$auth.user;
    },
    /**
     * ログインユーザー名を登録状況ごとに結合して返却する
     * @return {string} - ログインユーザー名のテキスト
     */
    userName() {
      if (!this.userData) {
        return "";
      } else if (this.userData.familyName && this.userData.firstName) {
        return this.userData.familyName + " " + this.userData.firstName;
      } else {
        return this.userData.familyName || this.userData.firstName;
      }
    },
    /**
     * ログインページからのリダイレクトするためのURLを生成して返却する
     * @return {string} - ログインページからのリダイレクトするためのURLテキスト
     */
     redirectUrl() {
      return (
        process.env.VUE_APP_AUTHORIZATION + "/v1/stay/login"
      );
    },
    /**
     * 「給トク払い」リンクの条件分岐フラグ
     * @param { void }
     * @return { boolean } boServiceCodeが「SD」の場合、給トクありのアカウント
     */
    isKyutokuMember() {
      let kyutokuFlg = false
      let containFlgs = []
      // ログインユーザが本人以外の場合FALSEで返却
      if (this.userData.ssoPrincipalFlg != 1) { return kyutokuFlg; };
      // contractInfoがなければFALSEで返却
      if (this.contractInfo?.length === 0){ return kyutokuFlg; };

      this.contractInfo.map(obj => {
        if (!obj || !obj.subscriptions) { return; }
        const filteredArr = obj.subscriptions.filter(obj => obj.boServiceCode === "SD")
        if (filteredArr.length > 0) return containFlgs.push(true)
        containFlgs.push(false)
      })
      
      if (containFlgs.includes(true)) kyutokuFlg = true
      return kyutokuFlg
    },
    /**
     * 給トクメンバーの場合、「給トク払い」リンク
     * @param { void }
     * @return { string }
     */
    qtokPaymentUrl() {
      return process.env.VUE_APP_WITH_QTOK_PAYMENT_URL
    },
  },
  methods: {
    /**
     * ログアウトの処理を行う
     */
    async loggedOut() {
      // CRM独自対応
      // window.dataLayer.push({
      //   event: "braze_logout",
      // });
      await this.$auth.remove();
      this.$nextTick(() => {
        this.$router.push("/");
        this.$emit("hide");
      });
    },
    /**
     * モーダル表示時にスクロールを固定する
     */
    fixScroll() {
      if (this.isShow) {
        document.documentElement.style.overflow = "hidden";
      } else {
        document.documentElement.style.overflow = "visible";
      }
    },
    /**
     *  画面のリサイズ中はプルダウンメニューを非表示にする
     */
    async hideSideMenuDuringResize() {
      this.hideSideMenu = true;
      if (this.resizeFlag !== false) {
        clearTimeout(this.resizeFlg);
      }
      const self = this;
      this.resizeFlg = await setTimeout(() => {
        self.hideSideMenu = false;
      }, 500);
    },
    // アカウント情報の取得
    async getContractInfo() {
      const { user } = this.$store.getters['auth/get'];
      if(user){
        this.contractInfo = [user.contract];
      }
    },
    formatNumber(value) {
      return value != null ? new Intl.NumberFormat().format(value) : "";
    },
  },
  mounted() {
    this.fixScroll();
    this.getContractInfo()
    window.addEventListener("resize", this.hideSideMenuDuringResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.hideSideMenuDuringResize);
  },
  watch: {
    isShow() {
      this.fixScroll();
    }
  }
};
</script>

<style lang="scss" scoped>
@import './style.scss';

.bg_red {
  background: #E60021;
}

.bg_pink {
  background: #FDF1F1;
}

.rounded_3px {
  border-radius: 3px;
}

@media only screen and (max-width: 638px) {
  .text-sp-base {
    font-size: 13px !important;
  }
}
</style>
